import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import clsx from 'clsx';
/**
 * PageContent - A semantic main element wrapper for page content.
 *
 * This component provides a consistent way to wrap page content with proper
 * semantic HTML using the <main> element. It supports accessibility attributes
 * and custom styling while maintaining semantic correctness.
 *
 * Features:
 * - Uses semantic <main> HTML element
 * - Full accessibility support with ARIA attributes
 * - Customizable styling with className prop
 * - TypeScript support with strict typing
 * - Lightweight and focused on semantic structure
 *
 * @example
 * ```tsx
 * <PageContent className="min-h-screen">
 *   <h1>Page Title</h1>
 *   <section>
 *     <p>Page content goes here...</p>
 *   </section>
 * </PageContent>
 * ```
 *
 * @example
 * // With accessibility attributes
 * ```tsx
 * <PageContent
 *   aria-label="Main content area"
 *   className="container mx-auto"
 * >
 *   <article>
 *     <h1>Article Title</h1>
 *     <p>Article content...</p>
 *   </article>
 * </PageContent>
 * ```
 */
export const PageContent = ({ children, className, id, role, 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledby, 'data-testid': dataTestId, }) => {
    return (_jsx("main", { id: id, className: clsx('', className), role: role, "aria-label": ariaLabel, "aria-labelledby": ariaLabelledby, "data-testid": dataTestId, children: children }));
};
//# sourceMappingURL=PageContent.js.map